const endorsementType = { id: 0, code: 'E', name: '' };
const mockEndorsementCoveragesList = [
  {
    id: 0,
    code: '006',
    applyDeductible: false,
    enableUI: true,
    name: 'ENDOSO PLATINO PLUS',
    minCost: 0,
    maxCost: 56,
    limits: [],
    type: { ...endorsementType },
  },
  {
    id: 0,
    code: '007',
    applyDeductible: false,
    enableUI: true,
    name: 'ENDOSO PLATINO',
    minCost: 0,
    maxCost: 56,
    limits: [],
    type: { ...endorsementType },
  },
  {
    id: 0,
    code: '008',
    applyDeductible: false,
    enableUI: true,
    name: 'ENDOSO DORADO PLUS',
    minCost: 0,
    maxCost: 0,
    limits: [],
    type: { ...endorsementType },
  },
];

export default mockEndorsementCoveragesList;
